export const marchUppercase = "ira";
export default {marchUppercase};